import * as AuthModals from '@features/authenticate/modals-index';
import * as OrderModals from '@features/ordering/modals/modals.index';
import * as AccountModals from '@features/account/modals/modals.index';
import * as CustomizationModals from '@features/customization/modals/modals.index';
import { ApplyForSupportModalComponent } from '@features/community/apply-for-support-modal/apply-for-support-modal.component';
import { VisitTutorialComponent } from '@features/visit/visit-tutorial/visit-tutorial.component';
import { PointsTutorialComponent } from '@features/rewards/modals/points-tutorial/points-tutorial.component';

import * as CheckoutModals from '@features/checkout/modals/modals.index';


export const ENTRYCOMPONENTSMAP = {
    'RegisterComponent': AuthModals.RegisterComponent,
    'ForgotPasswordComponent': AuthModals.ForgotPasswordComponent,
    'SigninModalComponent': AuthModals.SigninModalComponent,
    'SigninIncompleteComponent': AuthModals.SigninIncompleteComponent,
    'TemporaryPasswordComponent': AuthModals.TemporaryPasswordComponent,
    'TermNConditionComponent': AuthModals.TermNConditionComponent,
    'TncUpdateComponent': AuthModals.TncUpdateComponent,
    'SigninCodeComponent': AuthModals.SigninCodeComponent,
    'NutritionAllergensComponent': CustomizationModals.NutritionAllergensComponent,
    'ChooseYourMealComponent': CustomizationModals.ChooseYourMealComponent,
    'ApplyForSupportModalComponent': ApplyForSupportModalComponent,
    'VisitTutorialComponent': VisitTutorialComponent,
    'MyOrderSummaryComponent': OrderModals.MyOrderSummaryComponent,
    'OrderDetailComponent': OrderModals.OrderDetailComponent,
    'TimePickerComponent': OrderModals.TimePickerComponent,
    'AddFavoriteNameModalComponent': OrderModals.AddFavoriteNameModalComponent,
    'FormModalComponent': OrderModals.FormModalComponent,
    'CurbsideNospaceComponent': OrderModals.CurbsideNospaceComponent,
    'PickuptypeComponent': AccountModals.PickuptypeComponent,
    'EditFavoriteComponent': AccountModals.EditFavoriteComponent,
    'DeleteAccountConfirmationComponent': AccountModals.DeleteAccountConfirmationComponent,
    'PointsTutorialComponent': PointsTutorialComponent,

    'AddTipComponent': CheckoutModals.AddTipComponent,
    'ConfirmAddressComponent': CheckoutModals.ConfirmAddressComponent,
    'SelectPickupComponent': CheckoutModals.SelectPickupComponent,
    'CurbsideSpaceNumberComponent': OrderModals.CurbsideSpaceNumberComponent,
    'TableSpaceLetterComponent': OrderModals.TableSpaceLetterComponent,
    'ChangeOrderPickupTypeComponent': OrderModals.ChangeOrderPickupTypeComponent,

    'app-register': AuthModals.RegisterComponent,
    'app-forgot-password': AuthModals.ForgotPasswordComponent,
    'app-signin-body': AuthModals.SigninModalComponent,
    'app-signin-incomplete': AuthModals.SigninIncompleteComponent,
    'app-temporary-password': AuthModals.TemporaryPasswordComponent,
    'app-term-n-condition': AuthModals.TermNConditionComponent,
    'app-tnc-update': AuthModals.TncUpdateComponent,
    'app-signin-code': AuthModals.SigninCodeComponent,
    'app-jit-migration-modal': AuthModals.JitMigrationModalComponent,
    'app-migration-nudge-prompt': AuthModals.MigrationNudgePromptComponent,
    'app-identifier-first-signin': AuthModals.IdentifierFirstSigninComponent,
    'app-auth0-email-signup': AuthModals.Auth0EmailSignupComponent,
    'app-nutrition-allergens': CustomizationModals.NutritionAllergensComponent,
    'app-choose-your-meal': CustomizationModals.ChooseYourMealComponent,
    'app-apply-for-support-modal': ApplyForSupportModalComponent,
    'app-visit-tutorial': VisitTutorialComponent,
    'app-my-order-summary': OrderModals.MyOrderSummaryComponent,
    'app-order-detail': OrderModals.OrderDetailComponent,
    'app-time-picker': OrderModals.TimePickerComponent,
    'app-favname-body': OrderModals.AddFavoriteNameModalComponent,
    'app-form-modal': OrderModals.FormModalComponent,
    'app-curbside-nospace': OrderModals.CurbsideNospaceComponent,
    'pickuptype': AccountModals.PickuptypeComponent,
    'app-edit-favorite': AccountModals.EditFavoriteComponent,
    'app-delete-account-confirmation': AccountModals.DeleteAccountConfirmationComponent,
    'app-add-tip': CheckoutModals.AddTipComponent,
    'app-confirm-address': CheckoutModals.ConfirmAddressComponent,
    'app-select-pickup': CheckoutModals.SelectPickupComponent,
    'app-curbside-space-number': OrderModals.CurbsideSpaceNumberComponent,
    'guest-sign-up':OrderModals.GuestSignupComponent,
    'guest-signup-terms-conditions':OrderModals.GuestSignupTermsConditionsComponent,
    'app-table-space-letter': OrderModals.TableSpaceLetterComponent,
    'app-change-order-pickup-type': OrderModals.ChangeOrderPickupTypeComponent,
    'app-points-tutorial': PointsTutorialComponent,
  };
